'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hawaComponents = require("hawa-components");

var _printButton = _interopRequireDefault(require("../print-button"));

var _ouputTable = _interopRequireDefault(require("../ouput-table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var FormView = /*#__PURE__*/function (_React$Component) {
  _inherits(FormView, _React$Component);

  function FormView(props) {
    var _this;

    _classCallCheck(this, FormView);

    _this = _possibleConstructorReturn(this, (FormView.__proto__ || Object.getPrototypeOf(FormView)).call(this, props));
    _this.state = {
      hModeEnabled: false,
      graphConfig: _this.props.graphConfig
    };
    _this.showErrorMessage = _this.showErrorMessage.bind(_assertThisInitialized(_this));
    _this.changeValue = _this.changeValue.bind(_assertThisInitialized(_this));
    _this.changeHMode = _this.changeHMode.bind(_assertThisInitialized(_this));
    _this.onBlurField = _this.onBlurField.bind(_assertThisInitialized(_this));
    _this.getHError = _this.getHError.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(FormView, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var isHBiggerInHMode = this.props.data.rh.length === 0 && !this.state.hModeEnabled && this.props.data.selection === 'recessOneSideSolution';
      var isHBiggerInRHMode = this.props.data.h > this.props.data.rh && !this.state.hModeEnabled && this.props.data.selection === 'recessOneSideSolution';
      var isHBiggerBothSides = this.props.data.h > this.props.data.rh && this.props.data.selection === 'recessBothSidesSolution';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-form-view"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, this.showErrorMessage(), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-9"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-view-container"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.props.save
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 combo-selection"
      }, this.props.formConfig.fields.indexOf('sh') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputSelect, {
        pleaseChoose: this.props.texts.pleaseChoose,
        label: t('Höhe der Seitenwand'),
        onChange: this.changeHMode,
        options: this.props.heightOptions,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'sh';
        })[0],
        id: 'sh',
        name: 'sh',
        value: this.props.data.sh
      })), this.props.formConfig.fields.indexOf('gd') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputSelect, {
        pleaseChoose: this.props.texts.pleaseChoose,
        label: this.props.texts.gd,
        onChange: this.changeValue,
        options: this.props.glasThicknessOptions,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'gd';
        })[0],
        id: 'gd',
        name: 'gd',
        value: this.props.data.gd
      })), this.props.formConfig.fields.indexOf('colorProfile') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputSelect, {
        pleaseChoose: this.props.texts.pleaseChoose,
        label: this.props.texts.optics,
        onChange: this.changeValue,
        options: this.props.colorProfileOptions,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'colorProfile';
        })[0],
        id: 'colorProfile',
        name: 'colorProfile',
        value: this.props.data.colorProfile
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x small-up-1 medium-up-2 large-up-3",
        "data-equalizer-container": true
      }, this.props.formConfig.fields.indexOf('lb') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.lb,
        id: 'lb',
        name: "lb",
        range: this.props.formConfig.lb.range,
        value: this.props.data.lb,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'lb';
        })[0],
        onBlur: this.onBlurField
      })), this.props.formConfig.fields.indexOf('h') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.h,
        id: 'h',
        name: "h",
        range: this.props.formConfig.h.range,
        value: this.props.data.h,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'h';
        })[0],
        onBlur: this.onBlurField
      })), this.props.formConfig.fields.indexOf('al1') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.al1,
        id: 'al1',
        name: "al1",
        range: this.props.formConfig.al1.range,
        value: this.props.data.al1,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'al1';
        })[0],
        onBlur: this.onBlurField
      })), this.props.formConfig.fields.indexOf('al2') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.al2,
        id: 'al2',
        name: "al2",
        range: this.props.formConfig.al2.range,
        value: this.props.data.al2,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'al2';
        })[0],
        onBlur: this.onBlurField
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x small-up-1 medium-up-2 large-up-3",
        "data-equalizer-container": true
      }, this.props.formConfig.fields.indexOf('rh') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.rh,
        id: 'rh',
        name: "rh",
        range: this.props.formConfig.rh.range,
        value: !this.state.hModeEnabled ? this.props.data.rh : '',
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'rh';
        })[0],
        onBlur: this.onBlurField,
        disabled: this.state.hModeEnabled
      })), this.props.formConfig.fields.indexOf('t') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.t,
        id: 't',
        name: "t",
        range: this.props.formConfig.t.range,
        value: this.props.data.t,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 't';
        })[0],
        onBlur: this.onBlurField
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x small-up-1 medium-up-2 large-up-3",
        "data-equalizer-container": true
      }, this.props.formConfig.fields.indexOf('c') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.c,
        id: 'c',
        name: "c",
        value: this.props.formConfig.c.exact[0],
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'c';
        })[0],
        disabled: true
      })), this.props.formConfig.fields.indexOf('x') !== -1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.InputNumber, {
        label: this.props.texts.x,
        id: 'x',
        name: "x",
        value: this.props.data.x,
        change: this.changeValue,
        error: this.props.invalidFields.filter(function (field) {
          return field.fieldName === 'x';
        })[0],
        disabled: true
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: 'hide-for-print'
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.LargeButton, {
        text: this.props.texts.calculate,
        disabled: this.props.buttonDisabled || isHBiggerInHMode || isHBiggerInRHMode || isHBiggerBothSides
      }))), this.props.showTable && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_ouputTable.default, {
        data: this.props.tableData.data,
        headings: this.props.tableData.headings
      })), this.props.showTable && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'large-button-group hide-for-print'
      }, ['recessBothSidesSolution', 'recessOneSideSolution'].indexOf(this.props.data.selection) >= 0 && /*#__PURE__*/_react.default.createElement("span", {
        onClick: this.props.generatePdf,
        className: "pdf-button"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.LargeButton, {
        text: t('Plan mit individuellen Massen anzeigen')
      })), /*#__PURE__*/_react.default.createElement("span", {
        onClick: window.print,
        className: "print-button"
      }, /*#__PURE__*/_react.default.createElement(_printButton.default, {
        text: t('Artikelliste drucken')
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x large-5",
        "data-equalizer-container": true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-10 medium-7 large-6"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "disclaimer"
      }, t('disclaimer')))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-3 show-for-large"
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.GraphDisplay, {
        config: this.state.graphConfig
      }))));
    }
  }, {
    key: "getHError",
    value: function getHError() {
      var isHBiggerInRHMode = false;

      if (this.props.data.h && this.props.data.rh && !this.state.hModeEnabled && this.props.data.selection) {
        isHBiggerInRHMode = this.props.data.h >= this.props.data.rh && this.props.data.selection === 'recessOneSideSolution';
      }

      var isHBiggerBothSides = false;

      if (this.props.data.h && this.props.data.rh && this.props.data.selection) {
        isHBiggerBothSides = this.props.data.h >= this.props.data.rh && this.props.data.selection === 'recessBothSidesSolution';
      }

      if (isHBiggerInRHMode || isHBiggerBothSides) {
        this.props.getHError();
      }
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      var error = this.props.invalidFields.filter(function (field) {
        return !field.fieldName;
      })[0];
      if (!error) return;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-8 xlarge-7 general-error"
      }, /*#__PURE__*/_react.default.createElement("p", null, error.label));
    }
    /**
     *
     * @param e
     */

  }, {
    key: "changeValue",
    value: function changeValue(e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;
      this.props.changeData(name, value, e);
      this.getHError();
    }
    /**
     *
     * @param e
     */

  }, {
    key: "changeHMode",
    value: function changeHMode(e) {
      var _e$target2 = e.target,
          name = _e$target2.name,
          value = _e$target2.value;

      if (value < 1) {
        this.props.resetRh();
        this.setState({
          hModeEnabled: true,
          graphConfig: [{
            base: '/static/assets/images/graph-display/gf1_ansicht_H.png',
            ids: ['lh', 'h', 'c', 'x']
          }],
          rh: ''
        });
      } else {
        this.setState({
          hModeEnabled: false,
          graphConfig: this.props.graphConfig,
          rh: this.props.data.rh
        });
      }

      this.props.changeData(name, value, e);
    }
    /**
     *
     * @param e
     */

  }, {
    key: "onBlurField",
    value: function onBlurField(e) {
      var name = e.target.name;
      this.props.leaveField(name, e);
      this.getHError();
    }
  }]);

  return FormView;
}(_react.default.Component);

var propTypeInputField = _propTypes.default.shape({
  range: _propTypes.default.shape({
    min: _propTypes.default.any,
    max: _propTypes.default.any
  })
});

var propTypeData = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

FormView.propTypes = {
  t: _propTypes.default.func.isRequired,
  save: _propTypes.default.func.isRequired,
  generatePdf: _propTypes.default.func,
  getHError: _propTypes.default.func,
  texts: _propTypes.default.shape({
    calculate: _propTypes.default.string,
    pleaseChoose: _propTypes.default.string,
    colorProfile: _propTypes.default.string,
    lb: _propTypes.default.string,
    gd: _propTypes.default.string,
    h: _propTypes.default.string,
    rh: _propTypes.default.string,
    t: _propTypes.default.string,
    c: _propTypes.default.string,
    x: _propTypes.default.string,
    al1: _propTypes.default.string,
    al2: _propTypes.default.string,
    optics: _propTypes.default.string
  }),
  graphConfig: _propTypes.default.arrayOf(_propTypes.default.shape({
    base: _propTypes.default.string,
    ids: _propTypes.default.array
  })).isRequired,
  colorProfileOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.number,
    value: _propTypes.default.any
  })),
  glasThicknessOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.number,
    value: _propTypes.default.any
  })),
  heightOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.number,
    value: _propTypes.default.any
  })),
  buttonDisabled: _propTypes.default.bool,
  invalidFields: _propTypes.default.arrayOf(_propTypes.default.shape({
    fieldName: _propTypes.default.string
  })),
  resetRh: _propTypes.default.func,
  data: _propTypes.default.shape({
    selection: propTypeData,
    colorProfile: propTypeData,
    gd: propTypeData,
    lb: propTypeData,
    h: propTypeData,
    rh: propTypeData,
    t: propTypeData,
    c: propTypeData,
    x: propTypeData,
    al1: propTypeData,
    al2: propTypeData,
    sh: propTypeData
  }),
  formConfig: _propTypes.default.shape({
    lb: propTypeInputField,
    h: propTypeInputField,
    rh: propTypeInputField,
    t: propTypeInputField,
    c: propTypeInputField,
    al1: propTypeInputField,
    al2: propTypeInputField,
    fields: _propTypes.default.array,
    mandatory: _propTypes.default.array
  }).isRequired,
  changeData: _propTypes.default.func.isRequired,
  leaveField: _propTypes.default.func.isRequired,
  showTable: _propTypes.default.bool,
  tableData: _propTypes.default.shape({
    data: _propTypes.default.object,
    headings: _propTypes.default.object
  })
};
var _default = FormView;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-view/index.js
// module id = 554
// module chunks = 0